/* eslint-disable react-hooks/exhaustive-deps */
import { BoxProps } from "@chakra-ui/react"
import * as React from "react"
import { ChatPolls } from "../polls/chat-polls"
import { ChatInput } from "./_chatInput"
import { ChatScreen } from "./_chatScreen"
import { pollsAtom } from "../../../recoil/atoms/polls"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { reactionsStatusSelector } from "../../../recoil/atoms/chats"
import { useSessionStorage } from "../../../hooks/useSessionStorage"
import { brandingSelector, roomSelector } from "../../../recoil/atoms/room"
import useLocalUserHasPermissions from "../../../hooks/useLocalUserHasPermissions"

interface ChatProps extends BoxProps {
  display?: string
  servicePanelBackgroundColor?: string
}

export interface ChatStyles {
  servicePanelElementBorder: string
  accessButtonBackgroundColor: string
  accessButtonMouseoverColor: string
  accessButtonTextMouseoverColor: string
  accessButtonTextColor: string
  secondaryAccessButtonBackgroundColor: string
  secondaryAccessButtonBorderColor: string
  secondaryAccessButtonTextColor: string
  secondaryAccessButtonMouseoverColor: string
  secondaryAccessButtonTextMouseoverColor: string
  servicePanelElementBackground: string
  servicePanelElementPrimaryText: string
  commentTextColor: string
  commentFontFamily: string
  servicePanelElementLabels: string
  commentBackgroundColor: string
  servicePanelElementBorderOffset: string
  servicePanelElementSecondaryText: string
  servicePanelElementModalBackground: string
}

export const Chat = ({
  servicePanelBackgroundColor
}: ChatProps): JSX.Element => {
  const screenRef = React.useRef<HTMLDivElement>(null)
  const roomStyles = useRecoilValue(brandingSelector)

  const room = useRecoilValue(roomSelector)

  const styleschat = React.useMemo<ChatStyles>(() => {
    return {
      servicePanelElementBorder: roomStyles?.servicePanelElementBorder,
      accessButtonBackgroundColor: roomStyles?.accessButtonBackgroundColor,
      accessButtonMouseoverColor: roomStyles?.accessButtonMouseoverColor,
      accessButtonTextMouseoverColor:
        roomStyles?.accessButtonTextMouseoverColor,
      accessButtonTextColor: roomStyles?.accessButtonTextColor,
      secondaryAccessButtonBackgroundColor:
        roomStyles?.secondaryAccessButtonBackgroundColor,
      secondaryAccessButtonBorderColor:
        roomStyles?.secondaryAccessButtonBorderColor,
      secondaryAccessButtonTextColor:
        roomStyles?.secondaryAccessButtonTextColor,
      secondaryAccessButtonMouseoverColor:
        roomStyles?.secondaryAccessButtonMouseoverColor,
      secondaryAccessButtonTextMouseoverColor:
        roomStyles?.secondaryAccessButtonTextMouseoverColor,
      servicePanelElementBackground: roomStyles?.servicePanelElementBackground,
      servicePanelElementPrimaryText:
        roomStyles?.servicePanelElementPrimaryText,
      commentTextColor: roomStyles?.commentTextColor,
      commentFontFamily: roomStyles?.commentFontFamily,
      servicePanelElementLabels: roomStyles?.servicePanelElementLabels,
      commentBackgroundColor: roomStyles?.commentBackgroundColor,
      servicePanelElementBorderOffset:
        roomStyles?.servicePanelElementBorderOffset,
      servicePanelElementSecondaryText:
        roomStyles?.servicePanelElementSecondaryText,
      servicePanelElementModalBackground:
        roomStyles?.servicePanelElementModalBackground
    }
  }, [
    roomStyles?.accessButtonBackgroundColor,
    roomStyles?.accessButtonMouseoverColor,
    roomStyles?.accessButtonTextColor,
    roomStyles?.accessButtonTextMouseoverColor,
    roomStyles?.commentBackgroundColor,
    roomStyles?.commentFontFamily,
    roomStyles?.commentTextColor,
    roomStyles?.secondaryAccessButtonBackgroundColor,
    roomStyles?.secondaryAccessButtonBorderColor,
    roomStyles?.secondaryAccessButtonMouseoverColor,
    roomStyles?.secondaryAccessButtonTextColor,
    roomStyles?.secondaryAccessButtonTextMouseoverColor,
    roomStyles?.servicePanelElementBackground,
    roomStyles?.servicePanelElementBorder,
    roomStyles?.servicePanelElementBorderOffset,
    roomStyles?.servicePanelElementLabels,
    roomStyles?.servicePanelElementPrimaryText,
    roomStyles?.servicePanelElementSecondaryText,
    roomStyles?.servicePanelElementModalBackground
  ])

  const polls = useRecoilValue(pollsAtom)
  const selectedPolls = polls.filter(el => el.isVisible === true)

  const setReactionsStatus = useSetRecoilState(reactionsStatusSelector)

  const { parseStorageData, storage } = useSessionStorage("reactions")
  const { canSendChat } = useLocalUserHasPermissions()

  React.useEffect(() => {
    if (storage) {
      setReactionsStatus({
        type: "DOWNLOAD",
        payload: { reactionsList: Object.entries(parseStorageData) }
      })
    }
  }, [])

  const chatApprovalRequired = React.useMemo(() => {
    return room.chatApprovalRequired
  }, [room.chatApprovalRequired])

  return (
    <>
      <ChatPolls />
      <ChatScreen
        selectedPollsLength={selectedPolls.length}
        screenRef={screenRef}
        styleschat={styleschat}
        chatApprovalRequired={chatApprovalRequired}
        canSendChat={canSendChat}
      />
      <ChatInput />
    </>
  )
}
